import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { candidateNetworkElementConfiguration } from '@api/manageNetworkElementConfigurations';

import {
	INetworkElementConfigurationCandidateDTO,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { ICandidateNetworkElementDTO } from '@interfaces/networkElements/dto/networkElements';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_CONFIGURATION_CANDIDATE } from '@constants/queryKeys';

interface IUseMutateNetworkElementCandidateReturned {
	isLoadingNetworkElementCandidate: boolean;
	candidateNetworkElementConfiguration: UseMutateAsyncFunction<
		ICandidateNetworkElementDTO[], any, INetworkElementConfigurationCandidateDTO, any
	>;
}

const useMutateNetworkElementCandidate = (onSuccess?: () => void): IUseMutateNetworkElementCandidateReturned => {
	const {
		isLoading,
		mutateAsync,
	} = useMutation<INetworkElementConfigurationCandidateDTO>({
		mutationKey: [NETWORK_ELEMENT_CONFIGURATION_CANDIDATE],
		mutationFn: candidateNetworkElementConfiguration,
		onSuccess,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingNetworkElementCandidate: isLoading,
		candidateNetworkElementConfiguration: mutateAsync,
	};
};

export default useMutateNetworkElementCandidate;
